export class LocationSubDivisionModel {
  id: any;
  locationId: number | undefined;
  subDivisionName: string | undefined;
  subDivisionKeyName: string | any;
  level: number | undefined;
}
